import { useCpmsBoGetEnergyDeliveredByConnectorTypeQuery } from '@service/cpms-bo-transaction-reports-energy-statistics.service';

import {
  ByConnectorTypeCard,
  ByConnectorTypeCardVariantEnum,
} from '../../components/by-connector-type-card/by-connector-type.card';
import { useFilters } from '../../context/filters.context';

export const EnergyByConnectorTypeCard = (): React.JSX.Element => {
  const { transformedFilters } = useFilters();
  const { data } = useCpmsBoGetEnergyDeliveredByConnectorTypeQuery({
    ...transformedFilters,
  });

  return (
    <ByConnectorTypeCard
      data={data}
      variant={ByConnectorTypeCardVariantEnum.Energy}
    />
  );
};
